var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "remove",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.382,
    height: 22.382,
    viewBox: "0 0 22.382 22.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_720",
    "data-name": "Caminho 720",
    d: "M11.191,22.382A11.191,11.191,0,1,1,22.382,11.191,11.2,11.2,0,0,1,11.191,22.382Zm0-20.983a9.792,9.792,0,1,0,9.792,9.792A9.8,9.8,0,0,0,11.191,1.4Zm0,0",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_721",
    "data-name": "Caminho 721",
    d: "M161.516,169.1a.7.7,0,0,1-.494-1.194l6.924-6.924a.7.7,0,0,1,.99.99l-6.924,6.924a.7.7,0,0,1-.5.205Zm0,0",
    transform: "translate(-153.787 -153.746)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_722",
    "data-name": "Caminho 722",
    d: "M168.418,169.117a.693.693,0,0,1-.494-.205L161,161.989a.7.7,0,0,1,.989-.989l6.924,6.924a.7.7,0,0,1-.5,1.194Zm0,0",
    transform: "translate(-153.766 -153.765)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.a9cb88104911be17fc92496bbd594d52.svg";
export { ForwardRef as ReactComponent };